import { TitleButton } from '@/common/buttons/TitleButton';
import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { GridConstants } from '@/common/grid/GridConstants';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useCallback, useRef, useState } from 'react';

export const CtrtAmendmentList = ({ ctrtObj }) => {
  const entityListRef = useRef();
  const { navigateTo } = useNavState();
  const rsrc = useRsrc();
  const [isCompareDisabled, setIsCompareDisabled] = useState(true);

  const handleSelectionChanged = (event) => {
    const gridApi = event.api;
    const selectedNodeData = gridApi.getSelectedNodes().map((node) => node.data);
    if (selectedNodeData.length !== 2) {
      setIsCompareDisabled(true);
      return;
    }
    const [first, second] = selectedNodeData;
    setIsCompareDisabled(!(first.type && first.type === second.type));
  };

  const augRowsReq = useCallback(
    (rowsReq) => {
      rowsReq.query = 'LATEST_AMENDMENT_BY_CODE';
      rowsReq.replaceParams = { code: ctrtObj.code };
    },
    [ctrtObj.code],
  );
  const navigateToCtrtCompare = () => {
    const gridApi = entityListRef.current.gridRef.current.gridApiRef.current;
    const selectedCtrts = gridApi.getSelectedRows();
    navigateTo('md/compare/ctrt', { ctrts: selectedCtrts });
  };

  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons);
    tabButtons.push(
      <TitleButton
        icon={fas.faPlus}
        toolTip="New Amendment"
        onClick={() => rsrc.store('md', 'CTRT_AMENDMENT_STORE_PLUGIN', { id: ctrtObj.id })}
      />,
      <TitleButton
        key="compareCtrtButton"
        icon={fas.faBalanceScale}
        disabled={isCompareDisabled}
        toolTip="Compare two Contracts"
        onClick={navigateToCtrtCompare}
      />,
    );
  };
  const augFieldDefs = (fieldToFieldDef) => {
    fieldToFieldDef.checkbox = GridConstants.checkbox;
  };
  return (
    <EntityList
      ref={entityListRef}
      entity="CTRT"
      augRowsReq={augRowsReq}
      augTabButtons={augTabButtons}
      augFieldDefs={augFieldDefs}
      gridOptions={{
        rowSelection: 'multiple',
      }}
      events={{
        onSelectionChanged: handleSelectionChanged,
      }}
    />
  );
};
